import { render, staticRenderFns } from "./AdmissionRecord.vue?vue&type=template&id=75893222&scoped=true"
import script from "./AdmissionRecord.vue?vue&type=script&lang=js"
export * from "./AdmissionRecord.vue?vue&type=script&lang=js"
import style0 from "./AdmissionRecord.vue?vue&type=style&index=0&id=75893222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75893222",
  null
  
)

export default component.exports